// @flow
import { patch, post } from 'util/api'

export function create(email: string, destination?: string): Promise<{}> {
  return post('/api/password-reset', { email, destination }).then(response => response.json)
}

export function update(token: string, password: string): Promise<{}> {
  return patch(`/api/password-reset/${token}`, { password }).then(response => response.json)
}
